<app-navbar />
<router-outlet />